<template>
  <div class="page-shell">
    <main class="flex-1">
      <RouterView />
    </main>
  </div>
</template>
